import type { TooltipPositionEvent } from "@progress/kendo-react-tooltip";

export const getTooltipPosition = ({ targetElement, element, position }: TooltipPositionEvent) => {
  const targetPosition = targetElement?.getBoundingClientRect();

  if (position === "bottom") {
    const top = targetPosition?.bottom !== undefined ? targetPosition?.bottom + 1 : 0;
    const left = targetPosition?.left ?? 0;
    return { top, left };
  }

  return {
    top:
      targetPosition?.top !== undefined && element.offsetHeight ?
        targetPosition?.top - element.offsetHeight + 5
      : 0,
    left:
      targetPosition?.left && targetElement?.offsetWidth ?
        targetElement.offsetWidth * 0.3 + targetPosition?.left
      : 0,
  };
};
